import React from 'react';
import { Popup } from 'semantic-ui-react';
import { FILE_EXTENSION_PNG_IMAGE, HAZARD_ICONS_PATH, separators } from '../../../../constants';
import { withTranslation } from 'react-i18next';

const OverviewTableHazard = ({ rowValue, hazardList, componentKey, pictogramSize, t }) => {
  if (rowValue) {
    let recordHazards = rowValue.split(';');
    let existingHazardsGroupByGhsCode = [];
    const hazardListDeepCopy = JSON.parse(JSON.stringify(hazardList));
    hazardListDeepCopy
      .filter(hazard => recordHazards.includes(JSON.stringify(hazard.id)))
      .forEach(hazard => {
        const exitingHazard = existingHazardsGroupByGhsCode.find(hz => {
          return hz.ghsCode === hazard.ghsCode;
        });
        if (exitingHazard !== undefined && exitingHazard !== null) {
          exitingHazard.name = exitingHazard.name + ', ' + hazard.name;
        } else {
          existingHazardsGroupByGhsCode.push(hazard);
        }
      });

    return existingHazardsGroupByGhsCode.map(hazard => (
      <Popup
        key={componentKey + '-' + hazard.id}
        trigger={
          <img
            src={window.location.origin + HAZARD_ICONS_PATH + hazard.id + FILE_EXTENSION_PNG_IMAGE}
            height={pictogramSize}
            className="hazardCell"
          />
        }
        content={hazard.name
          .split(separators.hazards)
          .map(name => t(name))
          .join(separators.hazards)}
      />
    ));
  }
  return null;
};

OverviewTableHazard.defaultProps = {
  pictogramSize: '50'
};

export default withTranslation()(OverviewTableHazard);
